// extracted by mini-css-extract-plugin
export var tags = "Tags-module--tags--28a57";
export var tags__header = "Tags-module--tags__header--0e746";
export var tags__link = "Tags-module--tags__link--08e6c";
export var tags__link_span = "Tags-module--tags__link_span--6857e";